import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react';
import { prepareHeaders } from '../utils/rtk-headers';
import { getEnvironment } from '../env/env';
import { refreshToken } from 'src/services/FetchRequest';
import { PATH_AUTH_SPA } from 'src/constants/spa-routes';
import { ERROR_MESSAGE_FRIENDLY } from 'src/shared/constants';
import { clearOnLogout } from 'src/utils/clear.util';

let isRefreshing = false;

const getUser = (): Record<string, any> => {
  let user: any = localStorage.getItem('user');
  user = user && user !== 'undefined' && JSON.parse(user);

  return user || {};
};

const getRefreshToken = () => {
  const user = getUser();

  return user && (user.refresh_token || user.refresh);
};

const staggeredBaseQueryWithBailOut = retry(
  async (args, api, extraOptions) => {
    const environment = await getEnvironment();
    const baseSSOUrl = environment.APP_SSO_BASE_URL;
    const urlPath = `/api/${args.url}`;
    const url = new URL(urlPath, baseSSOUrl);
    const updatedArgs = { ...args, url: url.toString() };
    const result = await fetchBaseQuery({
      baseUrl: baseSSOUrl,
      prepareHeaders,
    })(updatedArgs, api, extraOptions);

    if (result.error?.status === 400 || result.error?.status === 404) {
      retry.fail(result.error);
    }

    if (result.error?.status === 401 && !updatedArgs?.meta?.skipAuthRetry) {
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const refresh = getRefreshToken();
          const token = await refreshToken(refresh);
          if (token.error?.status === 401) {
            clearOnLogout();
            window.location.assign(PATH_AUTH_SPA.ROOT);
            retry.fail(result.error);
          }

          if (token.access_token) {
            const user = getUser();
            const newUser = {
              ...user,
              access_token: token.access_token,
            };

            localStorage.setItem('user', JSON.stringify(newUser));
          } else {
            localStorage.removeItem('user');
            window.location.assign(PATH_AUTH_SPA.ROOT);
            return token;
          }
        } catch (error) {
          return console.log('staggeredBaseQueryWithBailOut error', error);
        } finally {
          isRefreshing = false;
        }
      }
    }

    if (['FETCH_ERROR', 500].includes(result.error?.status)) {
      (result.error as any).error = ERROR_MESSAGE_FRIENDLY;
    }

    return result;
  },
  {
    maxRetries: 2,
  },
);

export const baseSsoApi = createApi({
  reducerPath: 'baseSsoApi',
  baseQuery: staggeredBaseQueryWithBailOut,
  tagTypes: [],
  endpoints: () => ({}),
});
